// segment puts analytics.js on window which is a bit awkward for typescript
declare const window: any;
let analytics: any = null;
export function setAnalytics(a: any): void {
  // for testing only
  analytics = a;
}

export function getAnalytics(): SegmentAnalytics.AnalyticsJS {
  // Setting analytics in a variable once led to a race condition
  // Sometimes analytics would not get window.analytics and would not change until a reload
  // This is a workaround that also allows the tests to use analytics with the current setup
  // window.analytics should be returned in every situation that is not testing
  return analytics ? analytics : window?.analytics;
}
